import { Component } from "@opten/compiler/metadata/component";

@Component({ className: "js-pagination" })
export class PaginationComponent {
	constructor(private element: HTMLElement) {
		const loadMore = element.querySelector(".js-load-more") as HTMLElement;
		const incrementAmount = 6;
		let currentLimit = 6;
		if (loadMore) {
			var mixer = mixitup(this.element, {
				pagination: {
					limit: currentLimit,
				},
				callbacks: {
					onMixEnd: (state) => {
						if (
							state.activePagination.limit >= state.totalMatching
						) {
							loadMore.classList.add("d-none");
						} else {
							loadMore.disabled = false;
						}
					},
				},
			});
		}

		if (loadMore) {
			loadMore.addEventListener("click", () => {
				currentLimit += incrementAmount;
				mixer.paginate({ limit: currentLimit });
			});
		}
	}
}
